<template>
  <div class="cookies pa-3" v-if="!cookieSaved">
    <v-card class="elevation-6" dark>
      <v-card-title class="pb-0">
        <div class="title">Cookies {{cookieSaved}}</div>
      </v-card-title>
      <v-card-text class="pb-0">
        <p>Ten serwis wykorzystuje pliki cookies.
          Wszystkie informacje związane z ich używaniem oraz z informacjami o sposobie wyrażania
          i cofania zgody na używanie cookies, zostały opisane w
          <router-link to="/polityka-prywatnosci">Polityce Prywatności</router-link>.
          Korzystając z serwisu akceptujesz jej postanowienia.</p>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer>
        </v-spacer>
        <v-btn
          color="primary"
          @click.native="setCookies"
        >
          Akceptuj
        </v-btn>

      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'cookies',
  data: () => ({
    cookieSaved: true,
  }),
  methods: {
    verifyCookie() {
      this.cookieSaved = Cookies.get('cookie-info');
    },
    setCookies() {
      Cookies.set('cookie-info', true);
      this.cookieSaved = true;
    },
  },
  mounted() {
    this.verifyCookie();
  },
};
</script>
